import type { IntegrationDataHook } from "@/features/integrations/shared/renderer/hooks/types";

const hooks = new Map<string, IntegrationDataHook>();

export function registerChatIntegrationDataHook(
  integrationName: string,
  hook: IntegrationDataHook,
) {
  hooks.set(integrationName, hook);
}

export function getChatIntegrationDataHook(
  integrationName: string,
): IntegrationDataHook | undefined {
  return hooks.get(integrationName);
}
